<template>
  <a-modal :title="'新增运营商四要素认证'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="认证人员姓名" prop="name">
        <a-input v-model="form.name" placeholder="请输入认证人员姓名" />
      </a-form-model-item>
      <a-form-model-item ref="phoneNo" label="认证人员手机号" prop="phoneNo">
        <a-input v-model="form.phoneNo" placeholder="请输入认证人员手机号" />
      </a-form-model-item>
      <a-form-model-item ref="identifyCardNO" label="认证人员身份证号" prop="identifyCardNO">
        <a-input v-model="form.identifyCardNO" placeholder="请输入认证人员身份证号" />
      </a-form-model-item>
      <a-form-model-item ref="photo" label="人脸正面照" prop="photo">
        <div class="upload-container" @drop.prevent="handleDrop" @dragover.prevent @dragenter.prevent>
          <div v-if="!form.photo" class="upload-placeholder">
            <a-icon type="upload" />
            <div class="upload-text">拖拽图片到此处或点击上传</div>
            <input type="file" ref="fileInput" style="display: none" accept="image/*" @change="handleFileChange" />
            <a-button type="primary" @click="$refs.fileInput.click()">选择图片</a-button>
          </div>
          <div v-else class="preview-container">
            <img :src="form.photo" class="preview-image" />
            <div class="preview-actions">
              <a-button type="danger" @click="removeImage">删除</a-button>
            </div>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>
    <a-alert message="重要提醒！" description="1. 请认证核对提交的表单要素信息。 2.由第三方平台【云信平台】审核，提交后并且不可修改直到审核状态变更。 3.请勿重复提交。"
      type="info" show-icon />
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        name: "",
        phoneNo: "",
        identifyCardNO: "",
        photo: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入认证人员姓名",
            trigger: "blur",
          },
        ],
        phoneNo: [
          {
            required: true,
            message: "请输入认证人员手机号",
            trigger: "blur",
          },
          {
            pattern: /^(1[3-9]\d{9}|[569]\d{7}|9\d{8})$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        identifyCardNO: [
          {
            required: true,
            message: "请输入认证人员身份证号",
            trigger: "blur",
          },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "请输入正确的身份证号",
            trigger: "blur",
          },
        ],
        photo: [
          {
            required: true,
            message: "请上传现场照片",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.vip_id = id;
      if (id) {
        this.$http({
          url: "/admin/viplist/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = { ...res.data }
        });
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
          };
          this.$http({
            url: "/admin/yunxin/realNameAuth",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success("操作成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    async handleDrop(e) {
      const file = e.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        await this.processImage(file);
      } else {
        this.$message.error('请上传图片文件');
      }
    },

    async handleFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        await this.processImage(file);
      }
    },

    async processImage(file) {
      try {
        const compressedBase64 = await this.compressImage(file);
        console.log(compressedBase64)
        this.form.photo = compressedBase64;
        //重新校验表单中的photo
        this.$refs.ruleForm.validateField('photo');
      } catch (error) {
        this.$message.error('图片处理失败');
        console.error(error);
      }
    },

    async compressImage(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {

            const calculateBase64Size = (base64) => {
              if (!base64) return 0
              const padding = (base64.match(/=/g) || []).length
              return Math.ceil(base64.length * 3 / 4) - padding
            }
            const compress = (width, height, quality) => {
              const canvas = document.createElement('canvas');
              canvas.width = width;
              canvas.height = height;

              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, width, height);

              const base64 = canvas.toDataURL('image/jpeg', quality);

              // 计算base64字符串的大小（字节）
              const base64Size = calculateBase64Size(base64)
              // 如果大小超过32K，继续压缩
              if (base64Size > 32 * 1024) {
                // 如果质量还可以继续降低
                if (quality > 0.1) {
                  return compress(width, height, quality * 0.6);
                }
                // 如果质量已经最低，则缩小尺寸
                return compress(width * 0.8, height * 0.8, 0.1);
              }

              return base64;
            };

            // 从原始尺寸和0.5的质量开始压缩
            const compressedBase64 = compress(img.width, img.height, 0.6);
            resolve(compressedBase64);
          };
          img.onerror = reject;
        };
        reader.onerror = reject;
      });
    },

    removeImage() {
      this.form.photo = '';
    },
  },
};
</script>

<style scoped>
.upload-container {
  border: 2px dashed #d9d9d9;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-container:hover {
  border-color: #1890ff;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.upload-text {
  color: #999;
  margin: 8px 0;
}

.preview-container {
  position: relative;
  display: inline-block;
}

.preview-image {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
}

.preview-actions {
  margin-top: 8px;
  text-align: center;
}
</style>